// src/components/Hero.jsx
/* global fbq */
import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import secondaryImage from '../assets/images/zenzzz-back-tub-2.png';

const Hero = ({ price, productImage }) => {
    const [currentImage, setCurrentImage] = useState(productImage); // Start with primary image
    const images = [productImage, secondaryImage]; // Array for easy extension
    const { addToCart } = useCart();
    const toggleImage = () => {
        setCurrentImage(currentImage === productImage ? secondaryImage : productImage);
    };
    const prevImage = () => {
        setCurrentImage(prev => images[(images.indexOf(prev) - 1 + images.length) % images.length]);
    };
    fbq('track', 'ViewContent Hero Section');
    return (

        <section className="hero">
            <div className="container">
                <div className="hero-content">
                    <div className="hero-text">
                        <h2 className="hero-title">Get Your Zzen On Naturally</h2>
                        <p className="hero-subtitle">
                            Zenzzz helps quiet your mind, relax your body, and ease you into deep, uninterrupted
                            sleep <strong>without melatonin</strong>, and without the morning fog.
                        </p>
                        <ul className="hero-benefits">
                            <li>🌸 Herbal calm that feels like a nightly ritual</li>
                            <li>🌙 Deep, natural sleep, no drowsy side effects</li>
                            <li>🔬 Clinically inspired formula with ingredients that work</li>
                        </ul>
                        <button className="cta-button" onClick={() => {
                            addToCart();
                            if (window.gtag) {
                                window.gtag('event', 'add_to_cart', {
                                    currency: 'USD',
                                    value: 39.99,
                                    items: [{
                                        item_id: 'zenzzz-001',
                                        item_name: 'Zenzzz Lavender Honey',
                                        price: 39.99,
                                        quantity: 1
                                    }]
                                });
                            }
                            fbq('track', 'AddToCart using hero section', { value: 39.99, currency: 'USD' });
                        }}>
                            Add to Cart - ${price}
                        </button>
                    </div>
                    <div className="hero-image-carousel">
                        <img src={currentImage} alt="Zenzzz Sleep Supplement Jar" className="carousel-img" />
                        <button className="carousel-arrow left" onClick={prevImage} aria-label="Previous Image">
                            ◀
                        </button>
                        <button className="carousel-arrow right" onClick={toggleImage} aria-label="Next Image">
                            ▶
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;